export const captchaWhatsThisToggle = () => {
    var $captchaWhatsThis = $('.captcha-whats-this'),
        $captchaSpeakerTooltip = $('.captchaSpeakerTooltip');
    $captchaWhatsThis.on('click', function() {
        var $whatsThisContent = $(this).parents(".captchaContainer").find(".captcha-whats-this-content");
        $whatsThisContent.toggle();
    });
    if ($captchaSpeakerTooltip.length > 0) $captchaSpeakerTooltip.tooltip();
};
